import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Session } from '../services/session';
import { FleetGrowthFeatureFlagService } from '@services/feature-flags/growth';

export interface ICompanyGuard {
  name: string;
  redirectTo: string;
  isUpsellRoute: boolean
}

@Injectable()
export class CompanyFeatureEnabledGuard {
  public isUpsellFeatureFlagEnabled: boolean;

  constructor(
    private router: Router,
    private session: Session,
    private fgFeatureFlagService: FleetGrowthFeatureFlagService,
  ) {
    this.isUpsellFeatureFlagEnabled = fgFeatureFlagService.isDashboardUpsellsEnabled();
  }

  public canActivate(route: ActivatedRouteSnapshot): boolean {
    const config: ICompanyGuard = route.data.companyFeatureEnabledGuard;
    if (Array.isArray(config)) {
      const guard: ICompanyGuard = this.checkForMultipleFeatures(config);
      if (guard) {
        this.router.navigate([guard.redirectTo]);
        return false;
      }
      return true;
    }
    const feature: string = config.name;
    const redirectTo: string = config.redirectTo || '';
    const isProTrialActivated: boolean = this.session.isFeatureTrial();
    const isUpsellRoute: boolean = !!config.isUpsellRoute;

    if (this.session.isCompanyFeatureEnabled(feature)) {
      // restrict upsell route if company feature is enabled
      if (isUpsellRoute) {
        this.router.navigate([redirectTo]);
        return false;
      }
      return true;
    } else {
      // allow upsell route if company lacks a feature
      if (isUpsellRoute) return true;
      if (this.isUpsellFeatureFlagEnabled && isProTrialActivated) return true;
      this.router.navigate([redirectTo]);
      return false;
    }
  }

  private checkForMultipleFeatures(config: ICompanyGuard[]): ICompanyGuard {
    return config.find(feature => this.session.isCompanyFeatureEnabled(feature.name) === false);
  }
}
